/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_A2 as A2,
  rec_AccionAsync as AccionAsync,
  rec_B0 as B0,
  rec_Bo as Bo,
  rec_BuscarPersonaOrganigrama as BuscarPersonaOrganigrama,
  rec_Componente_i3_105_51 as Componente_i3_105_51,
  rec_Componente_o3_111_51 as Componente_o3_111_51,
  rec_Componente_r3_114_51 as Componente_r3_114_51,
  rec_Componente_r4_114_52 as Componente_r4_114_52,
  rec_EA as EA,
  rec_EscaleraOrganigrama as EscaleraOrganigrama,
  rec_EstadoError as EstadoError,
  rec_Fo as Fo,
  rec_FormularioPuesto as FormularioPuesto,
  rec_Go as Go,
  rec_H0 as H0,
  rec_ImportacionNisira as ImportacionNisira,
  rec_JSXRuntime as JSXRuntime,
  rec_K0 as K0,
  rec_L0 as L0,
  rec_LienzoOrganigrama as LienzoOrganigrama,
  rec_Lo as Lo,
  rec_MarcaCarga as MarcaCarga,
  rec_N0 as N0,
  rec_Q0 as Q0,
  rec_Q4 as Q4,
  rec_React as React,
  rec_SelectorMultiple as SelectorMultiple,
  rec_T2 as T2,
  rec_TablaOrganigrama as TablaOrganigrama,
  rec_V0 as V0,
  rec_W0 as W0,
  rec_Y4 as Y4,
  rec_Z4 as Z4,
  rec_Za as Za,
  rec_api as api,
  rec_b as b,
  rec_e3 as e3,
  rec_ii as ii,
  rec_q0 as q0,
  rec_t3 as t3,
  rec_z0 as z0,
} from "../../runtime/index.jsx";
export function GestionOrganigrama() {
  let e = Go(),
    { confirmar: t, pedirTexto: n } = Fo(),
    [r, i] = (0, React.useState)(null),
    [a, o] = (0, React.useState)(``),
    [s, c] = (0, React.useState)({
      texto: ``,
      alerta: ``,
      inactivos: !1,
    }),
    [l, u] = (0, React.useState)(Z4),
    [f, p] = (0, React.useState)(null),
    [m, h] = (0, React.useState)(!1),
    [g, _] = (0, React.useState)(null),
    v = (0, React.useCallback)(async () => {
      o(``);
      try {
        (i(
          await api(`/organigrama`, {
            sinCache: !0,
          }),
        ),
          _(Date.now()));
      } catch (e) {
        o(e.message);
      }
    }, []);
  (0, React.useEffect)(() => {
    v();
  }, [v]);
  let y = (0, React.useMemo)(() => r?.puestos ?? [], [r]),
    [x, S] = (0, React.useState)({}),
    C = (0, React.useMemo)(() => K0(A2(y, x), s), [y, x, s]),
    w = (0, React.useMemo)(() => q0(y), [y]),
    [T, E] = (0, React.useState)(`hoja`),
    [D, O] = (0, React.useState)(null),
    k = (0, React.useMemo)(() => y.filter((e) => e.activo), [y]),
    A = (0, React.useMemo)(() => A2(k, x), [k, x]),
    j = (0, React.useMemo)(() => T2(A, k), [A, k]),
    M = JSON.stringify(x),
    N = (0, React.useMemo)(
      () => [
        {
          value: ``,
          label: `(Sin subgrupo)`,
        },
        ...(r?.niveles ?? [])
          .filter((e) => e.activo)
          .map((e) => ({
            value: e.subgrupo,
            label: `${e.subgrupo} · ${e.nivel}`,
          })),
      ],
      [r],
    ),
    P = (0, React.useMemo)(() => V0(y), [y]);
  function F(e) {
    (c((t) => ({
      ...t,
      ...e,
    })),
      u(Z4));
  }
  function I(e) {
    i((t) => ({
      ...t,
      puestos: t.puestos.some((t) => t.id === e.id)
        ? t.puestos.map((t) =>
            t.id === e.id
              ? e
              : (e.dni && t.dniJefe === e.dni) || t.puestoJefe === e.id
                ? {
                    ...t,
                    nombreJefe: e.apenom,
                    cargoJefe: e.cargoCorrecto,
                  }
                : t,
          )
        : [...t.puestos, e],
    }));
  }
  let L = (0, React.useRef)(null);
  (0, React.useEffect)(() => {
    L.current = r;
  }, [r]);
  let R = (0, React.useRef)(new Map());
  function z(t, n, r) {
    let i = (R.current.get(t.id) ?? Promise.resolve()).then(async () => {
      let i = L.current,
        a = i?.puestos.find((e) => e.id === t.id) ?? t,
        o =
          n === `dniJefe`
            ? B0(L0(a), r)
            : {
                ...L0(a),
                [n]: r,
              };
      try {
        let e = await api(`/organigrama/${a.id}`, {
          method: `PUT`,
          body: JSON.stringify({
            version: a.version,
            datos: o,
          }),
        });
        return (
          i &&
            (L.current = {
              ...i,
              puestos: i.puestos.map((t) => (t.id === e.id ? e : t)),
            }),
          I(e),
          !0
        );
      } catch (t) {
        return (e.error(t.message), !1);
      }
    });
    return (R.current.set(t.id, i), i);
  }
  async function ee(n, r = !1) {
    if (
      !r &&
      !(await t({
        titulo: `Importar NISIRA`,
        mensaje: `Se reemplaza toda la información de NISIRA por la de este archivo. Lo que se escribió en el organigrama no se toca.`,
        confirmarTexto: `Importar`,
      }))
    )
      return;
    let i = new FormData();
    (i.append(`archivo`, n), r && i.append(`forzar`, `true`), h(!0));
    try {
      let t = await Za(`/organigrama/nisira`, i, {
        topeMs: 6e5,
      });
      (e.ok(`NISIRA actualizado: ${t3(t.personas)} personas`), await v());
    } catch (i) {
      if (
        i.status === 409 &&
        !r &&
        (await t({
          titulo: `El archivo trae menos personas`,
          mensaje: i.message,
          confirmarTexto: `Reemplazar igual`,
          peligro: !0,
        }))
      ) {
        await ee(n, !0);
        return;
      }
      e.error(i.message);
    } finally {
      h(!1);
    }
  }
  async function te({ tipo: t, puestos: n, generar: r }) {
    try {
      (await api(`/organigrama/descargas`, {
        method: `POST`,
        body: {
          tipo: t === `excel` ? `EXCEL` : `IMAGEN`,
          puestos: n,
        },
      }),
        await r(),
        e.ok(
          t === `excel`
            ? `Excel descargado: ${t3(n)} puestos`
            : `Organigrama descargado`,
        ));
    } catch (t) {
      e.error(t.message || `No se pudo descargar. Prueba de nuevo.`);
    }
  }
  async function B(r) {
    try {
      let i = await b(() => Promise.resolve().then(() => EA), void 0),
        a = i.read(await r.arrayBuffer(), {
          type: `array`,
        }),
        o = {
          puestos: [],
          salteadas: 0,
          encontrada: !1,
        };
      for (let e of a.SheetNames)
        if (
          ((o = Q0(
            i.utils.sheet_to_json(a.Sheets[e], {
              header: 1,
              raw: !0,
              defval: null,
            }),
          )),
          o.encontrada)
        )
          break;
      if (!o.puestos.length) {
        e.error(
          `El archivo no tiene una hoja con las columnas DNI y CARGO CORRECTO.`,
        );
        return;
      }
      let s = o.salteadas
          ? ` Se saltean ${o.salteadas} filas que no tienen DNI ni dicen VACANTE.`
          : ``,
        c = y.length > 0;
      if (c) {
        let t = await n({
          titulo: `Reemplazar el organigrama`,
          mensaje: `Los ${t3(y.length)} puestos de ahora se cambian por los ${t3(o.puestos.length)} del archivo.${s}\n\nLo que no esté en el archivo deja de estar en el organigrama, y no se puede deshacer. Las fotos se conservan.\n\nEscribí REEMPLAZAR para seguir.`,
          placeholder: `REEMPLAZAR`,
          confirmarTexto: `Reemplazar`,
          peligro: !0,
        });
        if (t == null) return;
        if (t.trim().toUpperCase() !== `REEMPLAZAR`) {
          e.error(`No se reemplazó: hay que escribir REEMPLAZAR.`);
          return;
        }
      } else if (
        !(await t({
          titulo: `Carga inicial`,
          mensaje: `Se van a cargar ${t3(o.puestos.length)} puestos.${s}`,
          confirmarTexto: `Cargar`,
        }))
      )
        return;
      let l = await api(
        `/organigrama/carga-inicial${c ? `?reemplazar=true` : ``}`,
        {
          method: `POST`,
          body: JSON.stringify(o.puestos),
        },
      );
      (e.logro(
        c ? `Organigrama reemplazado` : `Organigrama cargado`,
        `${t3(l.creados)} puestos`,
      ),
        await v());
    } catch (t) {
      e.error(t.message);
    }
  }
  let V = (0, React.useCallback)(
    (e, t, { terminar: n, cancelar: r }) =>
      e.editar === `subgrupo` ? (
        <Componente_r3_114_51
          valor={t.subgrupoTrabajo ?? ``}
          opciones={N}
          placeholder={`Elegí el subgrupo…`}
          onElegir={n}
          onCancelar={r}
        />
      ) : e.editar === `jefe` ? (
        <Componente_r3_114_51
          valor={z0(t)}
          opciones={P.filter((e) => e.value !== t.dni && e.puestoId !== t.id)}
          extra={H0}
          placeholder={`Buscá al jefe por nombre o escribí su DNI…`}
          onElegir={n}
          onCancelar={r}
        />
      ) : null,
    [N, P],
  );
  return r ? (
    <div
      className={`flex flex-col gap-4`}
      children={[
        <EstadoError mensaje={a} onReintentar={v} />,
        <ImportacionNisira
          nisira={r.nisira}
          leidaEn={g}
          vacio={y.length === 0}
          importando={m}
          onImportar={ee}
          onCargaInicial={B}
          onNuevo={() =>
            p({
              nuevo: !0,
            })
          }
          cifras={w}
        />,
        <div
          className={`grid grid-cols-2 gap-3 sm:hidden`}
          children={[
            <Componente_i3_105_51 titulo={`Puestos`} valor={w.puestos} />,
            <Componente_i3_105_51 titulo={`Vacantes`} valor={w.vacantes} />,
            <Componente_i3_105_51
              titulo={`Por revisar`}
              valor={w.porRevisar}
              alerta={!0}
            />,
            <Componente_i3_105_51
              titulo={`Cargo distinto a NISIRA`}
              valor={w.cargoDistinto}
              alerta={!0}
            />,
          ]}
        />,
        <div
          role={`tablist`}
          aria-label={`Cómo ver el organigrama`}
          className={`flex flex-wrap gap-1 border-b border-(--border)`}
          children={Y4.map((e) => (
            <button
              key={e.id}
              type={`button`}
              role={`tab`}
              aria-selected={T === e.id}
              onClick={() => E(e.id)}
              className={`-mb-px inline-flex min-h-11 items-center gap-2 border-b-2 px-3 py-2 text-sm transition ${T === e.id ? `border-(--accent) font-medium text-(--text-h)` : `border-transparent text-(--text) hover:text-(--text-h)`}`}
              children={[<e.icono className={`h-4 w-4`} />, ` `, e.label]}
            />
          ))}
        />,
        T === `hoja` ? (
          <JSXRuntime.Fragment
            children={[
              <BuscarPersonaOrganigrama
                filas={y}
                filtro={x}
                onFiltro={(e) => {
                  (S(e), u(Z4));
                }}
              />,
              <div
                className={`grid gap-2 sm:grid-cols-[1fr_16rem_auto] sm:items-center`}
                children={[
                  <input
                    aria-label={`Buscar en el organigrama`}
                    className={`${Lo} min-h-11`}
                    placeholder={`Buscar nombre, DNI, cargo, área o jefe…`}
                    value={s.texto}
                    maxLength={120}
                    onChange={(e) =>
                      F({
                        texto: e.target.value,
                      })
                    }
                  />,
                  <SelectorMultiple
                    value={s.alerta}
                    onChange={(e) =>
                      F({
                        alerta: e,
                      })
                    }
                    placeholder={`Todos los puestos`}
                    opciones={W0.filter((e) => e.value)}
                  />,
                  <MarcaCarga
                    checked={s.inactivos}
                    onChange={(e) =>
                      F({
                        inactivos: e,
                      })
                    }
                    children={`Ver inactivos`}
                  />,
                ]}
              />,
              <div
                className={`hidden flex-wrap items-center gap-3 text-xs text-(--text) sm:flex`}
                children={N0.map((e) => (
                  <span
                    key={e.id}
                    className={`inline-flex items-center gap-1.5`}
                    children={[
                      <span
                        className={`h-2.5 w-7 rounded-full border border-(--text)/30 ${Q4[e.id] || `bg-(--bg)`}`}
                      />,
                      e.label,
                    ]}
                  />
                ))}
              />,
              y.length === 0 ? (
                <p
                  className={`${Bo} text-sm text-(--text)`}
                  children={`Todavía no hay puestos. Hacé la carga inicial con tu Excel o agregá el primero.`}
                />
              ) : (
                <JSXRuntime.Fragment
                  children={[
                    C.length === 0 ? (
                      <p
                        className={`${Bo} text-sm text-(--text) sm:hidden`}
                        children={`Ningún puesto coincide con lo que buscás.`}
                      />
                    ) : (
                      <Componente_o3_111_51 filas={C.slice(0, l)} onAbrir={p} />
                    ),
                    C.length > l && (
                      <AccionAsync
                        variante={`secundario`}
                        className={`min-h-11 self-center sm:hidden`}
                        onClick={() => u((e) => e + Z4)}
                        children={[
                          `Mostrar `,
                          Math.min(Z4, C.length - l),
                          ` más`,
                        ]}
                      />
                    ),
                    <div
                      className={`hidden sm:block`}
                      children={
                        <TablaOrganigrama
                          etiqueta={`Organigrama`}
                          alto={`llenar`}
                          filas={C}
                          columnas={e3}
                          onGuardar={z}
                          editorEspecial={V}
                          onAbrirFila={p}
                          atenuada={(e) => !e.activo}
                        />
                      }
                    />,
                  ]}
                />
              ),
            ]}
          />
        ) : y.length === 0 ? (
          <p
            className={`${Bo} text-sm text-(--text)`}
            children={`Todavía no hay puestos. Hacé la carga inicial con tu Excel o agregá el primero.`}
          />
        ) : (
          <JSXRuntime.Fragment
            children={[
              <BuscarPersonaOrganigrama
                filas={k}
                filtro={x}
                onFiltro={S}
                personas={k}
                onBuscar={(e) => {
                  (A.some((t) => t.id === e) || S({}),
                    O({
                      id: e,
                    }));
                }}
              />,
              <Componente_r4_114_52 className={`-mt-1 px-1`} />,
              T === `escalera` ? (
                <EscaleraOrganigrama
                  key={M}
                  arbol={j}
                  onAbrir={p}
                  enfocar={D}
                />
              ) : (
                <LienzoOrganigrama
                  key={M}
                  arbol={j}
                  onAbrir={p}
                  enfocar={D}
                  onDescargar={te}
                  titulo={
                    x.seccion ||
                    x.area ||
                    x.gerenciaLinea ||
                    x.gerenciaCorporativa ||
                    `Organigrama completo`
                  }
                />
              ),
            ]}
          />
        ),
        f && (
          <FormularioPuesto
            fila={f.nuevo ? null : f}
            subgrupos={N}
            jefes={P}
            onCerrar={() => p(null)}
            onActualizada={I}
            onGuardado={(e) => {
              (I(e),
                p(null),
                T !== `hoja` &&
                  O({
                    id: e.id,
                  }));
            }}
          />
        ),
      ]}
    />
  ) : a ? (
    <EstadoError mensaje={a} onReintentar={v} />
  ) : (
    <div
      className={`flex justify-center py-16 text-(--text)`}
      children={(0, JSXRuntime.jsx)(ii, {
        className: `h-6 w-6 animate-spin`,
      })}
    />
  );
}
